// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__1QB9G","resendInfoText":"OnGoingPaymentBox_resendInfoText__qZ9Jc"};